import Vue from 'vue'

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor)

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)